// Re-export from context for backwards compatibility
export { useGoogleReview as useGoogleReviewPrompt } from '../contexts/GoogleReviewContext'
